import { render, staticRenderFns } from "./CopyToInviteForm.vue?vue&type=template&id=384b1477&scoped=true"
import script from "./CopyToInviteForm.vue?vue&type=script&lang=js"
export * from "./CopyToInviteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b1477",
  null
  
)

export default component.exports